import workspace from "../../workspace";
import RenderParts from "../../../helpers/renderParts";
import RenderFigures from "../../../helpers/renderFigures";

class ShapeMeasurementArrows {
  __shape;

  constructor(shape) {
    this.__shape = shape;
  }

  import = (data) => {
    void data
  }

  render = (ctx) => {
    if (workspace && workspace.getState().loading) return;
    //this.renderDimensionsInsideShape(ctx);
    if (!this.__shape.shapeAbsolute.getAbsolutePosition() && !this.__shape.shapeAbsolute.getSnappedWithShape()) {
      this.renderDimensionsOutsideShape(ctx);
    }
  }

  renderMeasurementArrows = (ctx) => {
    const points = this.__shape.getPointsPointField();
    RenderFigures.drawArrowsAroundPoints(ctx, points, 10)
  }

  renderMeasurementLength = (ctx) => {
    const points = this.__shape.getPointsPointField();
    RenderParts.drawMeasurementAroundPoints(ctx, points);
  }

  renderDimensionsOutsideShape = (ctx) => {
    ctx.save();
    ctx.beginPath();
    this.renderMeasurementArrows(ctx);
    this.renderMeasurementLength(ctx);
    ctx.closePath();
    ctx.restore();
  }
}

export default ShapeMeasurementArrows
